import React from "react";
import TrustLayout, { H2 } from "./TrustLayout";

export default function Privacy() {
  return (
    <TrustLayout
      meta={{
        path: "/privacy",
        kicker: "Your data",
        title: "Privacy Policy | Centennial",
        description:
          "Centennial's privacy policy: no accounts, no selling data, plan inputs stay in your browser. What we collect, what we don't, and the analytics we use.",
        h1: "Privacy Policy",
        reviewed: "June 2026",
      }}
    >
      <H2>The short version</H2>
      <p>
        There are no accounts. Your retirement plan inputs, medication lists, and workbook
        answers live in <strong>your browser's local storage</strong> — they are not saved on our
        servers. We never sell data.
      </p>

      <H2>What we do collect</H2>
      <p>
        <strong>Anonymous usage analytics</strong> (via PostHog): page views, feature usage, and
        aggregate calculator runs — used to improve the tools. <strong>Server logs</strong>:
        standard technical logs (endpoint, timestamp) for reliability. <strong>Voluntary
        submissions</strong>: if you join the ebook waitlist, submit a book, post a community
        scenario, send feedback, or use the contact form, we store what you submit.
      </p>

      <H2>What we do not collect</H2>
      <p>
        No accounts or passwords. No plan inputs stored server-side (community scenarios you
        explicitly share are the exception). No medication data ever leaves your browser. No
        advertising trackers, no data brokers.
      </p>

      <H2>Payments</H2>
      <p>
        Optional purchases are processed by Stripe. We never see or store card numbers; Stripe's
        own privacy policy governs payment data.
      </p>

      <H2>Sharing links</H2>
      <p>
        When you share a plan URL, the plan parameters are encoded in the link itself. Anyone
        with the link can view that plan — share accordingly.
      </p>

      <H2>Cookies and local storage</H2>
      <p>
        We use local storage for your saved scenarios and preferences, and analytics cookies for
        anonymous usage measurement. Clearing your browser storage removes your local data
        permanently — we cannot recover it, because we never had it.
      </p>

      <H2>Contact</H2>
      <p>Questions about privacy? Use the contact page — a human will respond.</p>
    </TrustLayout>
  );
}
